import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";

export default function MapSvg({ linkHover, handleLinkHover }) {
    const history = useHistory();
    const [activeZone, setActiveZone] = useState(null);
    const paris = useRef();
    const metropole_paris = useRef();
    const plaine_commune = useRef();
    const est_ensemble = useRef();
    const nanterre = useRef();

    const urlBase = "/zone/";

    useEffect(() => {
        linkHover && setActiveZone(linkHover);
    }, []);

    const handleClick = (url) => {
        history.push(url);
    };

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1373.4 1255.865">
            <defs>
                <filter id="dropshadow">
                    <feOffset in="SourceAlpha" dx="5" dy="5"></feOffset>
                    <feGaussianBlur
                        stdDeviation="5"
                        result="DROP"
                    ></feGaussianBlur>
                    <feFlood floodColor="#DF1348" result="COLOR"></feFlood>
                    <feComposite
                        in="DROP"
                        in2="COLOR"
                        operator="in"
                        result="SHADOW1"
                    ></feComposite>
                    <feComponentTransfer in="SHADOW1" result="SHADOW">
                        <feFuncA type="table" tableValues="0 .2"></feFuncA>
                    </feComponentTransfer>
                    <feMerge>
                        <feMergeNode in="SHADOW"></feMergeNode>
                        <feMergeNode in="SourceGraphic"></feMergeNode>
                    </feMerge>
                </filter>
            </defs>
            <g
                data-name="Groupe 5323"
                transform="translate(-198.979 -6406.535)"
            >
                <g
                    className="cursor_pointer metropole_du_grand_paris"
            data-name="Groupe 5324"
            /*
                    style={
                        activeZone && activeZone === "nanterre"
                            ? { filter: `url(#dropshadow)` }
                            : {}
                    }
                    onMouseOver={(e) => {
                        handleLinkHover("metropole_du_grand_paris");
                        setActiveZone("metropole_du_grand_paris");
                        metropole_paris?.current?.classList?.remove("is-hidden");
                    }}
                    onMouseOut={(e) => {
                        handleLinkHover(null);
                        setActiveZone(null);
                        metropole_paris?.current?.classList?.add("is-hidden");
                    }}
                    onClick={() =>
                        handleClick(`${urlBase}nanterre`)
                    }
                    */
                >
                    <path
                        fill="#cececa"
                        stroke="#fff"
                        strokeWidth="3"
                        d="M545.928 6736.495l-66.894-50.036-.615-35.155 2.306-39.657 50.878-42.772 62.299 27.32 41.26 7.043 26.931-7.681 36.935 19.977 10.147 29.419-3.447 1.651-62.447 18.905-53.336 36.2z"
                        data-name="95018 ARGENTEUIL"
                    ></path>
                    <path
                        fill="#cececa"
                        stroke="#fff"
                        strokeWidth="3"
                        d="M784.997 7429.417l-19.344 70.607-25.71 4-4.644-38.4-49.81 20.439-13.562-1.571-10.385-23.934 24.478-28.517-20.11-33.239-18.31-15.421-51.493-2.242-45.861-18.459-10.613-32.834-6.094-6.316.19-21.267-6.476-11.147-37.814-9.97-2.455-25.184-17.241-18.793-52.6 4.553 7.89-10.035-24.521-54.94-41.3 4.748-28.12-23.5 1.956-9.885-8.01-27.41-6.931-32.6 11.113-37.771 26.245-4.077-25.333-41.746 9.007-22.87-9.007-25.04 21.107-37.7 29.462-58.85 13.257-12.589 70.112-37.239 52.986-46.219 28.582-27.57 43.908-34.845 53.328-36.208 62.452-18.908 55.244 11.689 61.99 24.783 2.832 38.62-20.19 34.118-17.156 15.858-5.865 10.6-16.161 7.405 16.362 52.492-42.989 24.441-51.573 32.948-12.071 27.337-53.256-6.222-12.413 22.585-25.59-8.146-37.28 28.638-16.09 37.413-3.949 22.793 63.6 27.856 14.668 36.649 24.681 11.343 12.838-1.055 11.526 20.6 23.829-9.5 22.758 11.526 31.837 12.493 34.247 10.976 47.392 20.438-7.588 12.493-26.7 14.748 13.028 32.579-14.024 52.548 19.042 23.525-15.707 43.371-10.69 15.285-16.2 47.162z"
                        data-name="92 - HAUTS-DE-SEINE"
                    ></path>
                    <path
                        fill="#cececa"
                        stroke="#fff"
                        strokeWidth="3"
                        d="M1509.808 7202.184l-59.241-29.719-4.219-12.245.438-23.733-85.446-54.613 1.341-13.329-57.381-36.5-5.279 4.716-25.991-27.34-11.264 5.993-9-16.362-39.662-5.808-72.675 23.143-19.231 16.554-26.277-6.335-21.572 15.165-27.244-1.8-7.011.366-2.72-23.007-5.448-69.474-6.933-20.749-27.586-20.4-4.515-21.97-5.744-26.245-18.777-19.234-51.151-1.916-11.951.152-37.277.326-58.346 1.4-27.012 2.72-16.355-52.509 16.17-7.411 5.856-10.594 17.166-15.844 20.231-34.134-2.872-38.6-61.994-24.783-55.244-11.7 3.447-1.651-10.16-29.428 27.052-28.558 38.77 16.009 18.66 14.791 21.954-4.905 13.264 16.55 27.736-45.781 26.055 6.166 33.869-33.313 26.124 8.56 17.238 2.816 66.548 58.728 30.608-6.287 76.551 7.532 22.571.071 9.228 2.8 18.924-32.563 65.517-37.854 13.068 2 12.028-9.923 3.7-12.589 25.774-9.541 56.695-90.709 39.726.23 14.312-21.151 34-10 15.283 42.1 11.529 4.825 11.032 51.741-11.032 24.481-26.71 7.379 1.341 13.329 68.151 100.325 10.738 41.583 17.166 12.742.607 23.119-27.41 16.784-8.809 58.274 8.894 8.774-2.488 2.161-15.811 20.749 1.454 25.673-52.1 19.018-18.881 18.986 29.667 25.9-6.821 49.2 51.709 3.644-12.867 34.1-23.167 10.919 33.2 74.061 25.417 77.412z"
                        data-name="93 - SEINE-SAINT-DENIS"
                    ></path>
                    <path
                        fill="#cececa"
                        stroke="#fff"
                        strokeWidth="3"
                        d="M1454.773 7649.066l-60.483 11.614-12.422-36.472-35.323-5.17-11.184-19.154 7.3-5.616-22.059-23.66-30.146-86.624-68.086 21.624-24.436 5.728-6.444.112-27.156 2.354-34.436 21.681 3.492 25.152-22.176-22.527-7.283-18.347-13.329 5.17-55.827 24.321-8.652-31.853-65.21 23.022-42.377-.3-.684-29.788-1.611-70.417-42.418 28.638-36.05-9.063-25.863-27.49-18.435-9.771-8.352 7.259-29.117-22.6 16.21-47.162 10.69-15.285 15.707-43.371-19.04-23.524 14.024-52.548-13.027-32.591 26.7-14.748 7.585-12.493 31.989 4.865 23.829-9.541 9.308 8.761 20.807-1.644 69.188-36.018 35.247-13.743 44.6 19.977 26.437 2.816 18.149 18.905 65.565.486 12.132-30.736 4.029-49.58-51.755-22.184-54.336 12.522-11.959-4.445-17.313 31.113-7.625-9.805 6.094-36.392.959-10.075 7.011-.358 27.244 1.8 21.568-15.167 26.277 6.34 19.235-16.556 72.712-23.143 39.721 5.808 8.886 16.362 11.269-5.987 25.988 27.34 5.282-4.7 57.381 36.472-1.341 13.329 85.554 54.619-.489 23.741 4.157 12.237 59.238 29.715 11.264 5.287-13.209 33.7 19.432 15.542-31.19 72.584 10.425 8.87 41.1-3.773 22.344 47.2-46.085 2.129 5.378 38.043-31.5 25.823 18.471 47.502-38.091 34.134-32.748 54.253 1.812 6.781 14.791 24.1 8.878 7.681z"
                        data-name="94 - VAL-DE-MARNE"
                    ></path>
                    <g
                        ref={metropole_paris}
                        className="title_metropole_du_grand_paris is-hidden"
                        data-name="Groupe 5319"
                        transform="translate(-682.021 792.659)"
                    >
                        <path
                            fill="#cececa"
                            d="M0 0H426V41H0z"
                            data-name="Rectangle 2460"
                            transform="translate(881 6622.025)"
                        ></path>
                        <g
                            data-name="Groupe 5314"
                            transform="translate(-240 20)"
                        >
                            <text
                                fill="#fff"
                                data-name="métropole du grand paris"
                                fontFamily="Orkney-Bold, Orkney"
                                fontSize="28"
                                fontWeight="700"
                                transform="translate(1334 6632.025)"
                            >
                                <tspan x="-204.05" y="0">
                                    MÉTROPOLE DU GRAND PARIS
                                </tspan>
                                <tspan
                                    fontFamily="Orkney-Medium, Orkney"
                                    fontWeight="500"
                                ></tspan>
                            </text>
                            <path
                                fill="none"
                                stroke="#cececa"
                                strokeWidth="1"
                                d="M0 0L0 129.685"
                                data-name="Ligne 659"
                                transform="translate(1545.5 6513.841)"
                            ></path>
                        </g>
                    </g>
                </g>
                <g data-name="Groupe 5320">
                    <g
                        fill="#895f73"
                        stroke="#fff"
                        strokeWidth="1"
                        data-name="Groupe 5286"
                        transform="translate(315.638 6761.392)"
                    >
                        <g
                            className="cursor_pointer nanterre"
                            data-name="Groupe 5285"

                        >
                          <path
                                fill="#cececa"
                                d="M229.189 199.624l6.436-32.724-28.12-20.324 27.164-49.978 53.176 34-21.492 40.365z"
                                data-name="92062 PUTEAUX"
                            ></path>
                            <path
                                d="M165.171 179.609L62.68 96.047l13.217-12.605 70.152-37.223L199.035 0l23.212 56.454 6.741 20.845 5.792 19.25-27.164 49.978z"
                                data-name="92050 NANTERRE"
                                style={
                                              activeZone && activeZone === "nanterre"
                                                  ? { filter: `url(#dropshadow)` }
                                                  : {}
                                          }
                                          onMouseOver={(e) => {
                                              handleLinkHover("nanterre");
                                              setActiveZone("nanterre");
                                              nanterre?.current?.classList?.remove("is-hidden");
                                          }}
                                          onMouseOut={(e) => {
                                              handleLinkHover(null);
                                              setActiveZone(null);
                                              nanterre?.current?.classList?.add("is-hidden");
                                          }}
                                          onClick={() =>
                                              handleClick(`${urlBase}nanterre`)
                                          }
                            ></path>
                <path
                  fill="#cececa"
                                d="M287.958 130.563l-53.177-34.022-5.792-19.25 71.109-21.035 17.511 7.927 4.213-8.758 26.667-.941 21.032 16.472-35.134 15.015z"
                                data-name="92026 COURBEVOIE"
                            ></path>
                <path
                  fill="#cececa"
                                d="M110.344 320.959l-54.939-.037 1.916-12.2 33.29-17.933 7.473-23.431 40.694-12.357 12.027 20.094-18.115 32.6z"
                                data-name="92033 GARCHES"
                            ></path>
                            <path fill="#cececa"
                                d="M228.885 77.291l-6.741-20.845 75.594-29.133 2.258 28.943z"
                                data-name="92035 LA LGARENNE-COLOMBES"
                            ></path>
                            <path fill="#cececa"
                                d="M369.903 135.437l-35.628-49.4 35.139-15.023 8.312-5.247 43.747 36.758z"
                                data-name="92044 LEVALLOIS-PERRET"
                            ></path>
                            <path fill="#cececa"
                                d="M357.846 162.769l-53.256-6.231-12.414 22.593-25.59-8.162 21.492-40.365 46.315-44.578 35.628 49.4z"
                                data-name="92051 NEUILLY-SUR-SEINE"
                            ></path>
                            <path fill="#cececa"
                                d="M37.359 282.287l-25.36-41.738 9-22.878-9-25.032 21.147-37.7 29.462-58.852 102.483 83.562 9.429 22.047-28.35 21.19 7.625 9.469-15.2 22.7-40.691 12.357z"
                                data-name="92063 RUEIL-MALMAISON"
                            ></path>
                            <path fill="#cececa"
                                d="M208.654 330.922l-15.555 31.623-50.074-10.858-49.842-3.222 17.2-27.546 22.226-13.257 18.125-32.6-12.031-20.1 15.213-22.7 59.039 4.73-3.869 22.793z"
                                data-name="92064 SAINT-CLOUD"
                            ></path>
                            <path fill="#cececa"
                                d="M213.019 237.004l-59.041-4.729-7.588-9.469 28.313-21.19-9.429-22.047 42.334-33.026 28.12 20.324-6.439 32.724z"
                                data-name="92073 SURESNES"
                            ></path>
                            <path fill="#cececa"
                                d="M14.939 384.162l-8.01-27.418-6.933-32.6 11.112-37.781 26.247-4.074 60.725-14.935-7.355 23.431-33.408 17.933-1.916 12.2-27.241.31z"
                                data-name="92076 VAUCRESSON"
                            ></path>
                        </g>
                    </g>
                    <g
                        ref={nanterre}
                        className="title_paris_ouest_la_defense is-hidden"
                        data-name="Groupe 5316"
                        transform="translate(-727 91.659)"
                    >
                        <path
                            fill="#895f73"
                            d="M0 0H185V41H0z"
                            data-name="Rectangle 2460"
                            transform="translate(1151 6602.025)"
                        ></path>
                        <g data-name="Groupe 5314">
                            <text
                                fill="#fff"
                                data-name="PARIS OUEST LA DéfenSe"
                                fontFamily="Orkney-Bold, Orkney"
                                fontSize="28"
                                fontWeight="700"
                                transform="translate(1334 6632.025)"
                            >
                                <tspan x="-174.202" y="0">
                                    Nanterre
                                </tspan>
                                <tspan
                                    fontFamily="Orkney-Medium, Orkney"
                                    fontWeight="500"
                                ></tspan>
                            </text>
                            <path
                                fill="none"
                                stroke="#895f73"
                                strokeWidth="1"
                                d="M0 0L0 194"
                                data-name="Ligne 659"
                                transform="translate(1151.5 6609.525)"
                            ></path>
                        </g>
                    </g>
                </g>
                <g
                    className="cursor_pointer paris"
                    data-name="Groupe 5321"
                    style={
                        activeZone && activeZone === "paris"
                            ? { filter: `url(#dropshadow)` }
                            : {}
                    }
                    onMouseOver={(e) => {
                        handleLinkHover("paris");
                        setActiveZone("paris");
                        paris?.current?.classList?.remove("is-hidden");
                    }}
                    onMouseOut={(e) => {
                        handleLinkHover(null);
                        setActiveZone(null);
                        paris?.current?.classList?.add("is-hidden");
                    }}
                    onClick={() =>
                        handleClick(`${urlBase}paris`)
                    }
                >
                    <path
                        fill="#c1ce27"
                        d="M715.525 412.367l-.959 10.075-6.2 36.395 7.748 9.8 17.31-31.1 11.956 4.443 54.3-12.533 51.795 22.184-4.1 49.572-12.039 30.728-65.557-.478-18.157-18.913-26.466-2.816-44.596-19.983-35.211 13.736-69.309 36.018-20.677 1.651-9.308-8.75-23.91 9.541-31.909-4.868-47.392-20.436-34.254-10.979-31.877-12.485-22.8-11.534-23.717 9.5-11.534-20.589-12.836 1.054-24.674-11.344-14.671-36.649-63.6-27.848 3.869-22.8 16.172-37.415 37.278-28.653 25.593 8.162 12.41-22.584 53.259 6.223 12.068-27.337 51.565-32.948 42.991-24.441 27.009-2.7 58.354-1.421 37.319-.326 11.831-.152 51.268 1.932 18.772 19.218 5.752 26.245 4.411 21.97 27.626 20.4 6.971 20.749 5.482 69.5z"
                        data-name="75 - PARIS"
                        transform="translate(324.676 6627.989)"
                    ></path>
                    <g
                        fill="#c1ce27"
                        stroke="#fff"
                        strokeWidth="0.5"
                        data-name="Groupe 5312"
                        transform="translate(120 -140)"
                    >
                        <path d="M722.004 7098.249l-16.493 4.12c-9.073 2.266-20.1 4.7-20.215 4.788l-1.713.868-1.715.868-2.533 4.189c-2.271 3.762-2.789 4.881-5.06 10.957a47.933 47.933 0 00-2.3 6.973c.126.112 2.5 1 5.274 1.972s11.171 4.307 18.657 7.417c12.138 5.039 15.074 6.137 27.113 10.153 7.329 2.445 13.426 4.443 13.744 4.51 1.05.457 3.615 1.178 4.844 1.6a56.585 56.585 0 019.739 5.119c.369.323 4.879 2.554 10.019 4.953 8.641 4.034 9.517 4.507 11.606 6.257a14.283 14.283 0 012.37 2.284c.307 1.061 1.6 8.737 1.6 9.485 0 1.269.126 1.467 2.894 4.47a18.959 18.959 0 002.72 2.658 4.442 4.442 0 00.4-1.477c.256-1.576.58-2.044 1.405-2.036a32.157 32.157 0 013.978 1.042c1.868.569 3.415 1.01 3.433.975.438-.684 7.2-21.529 7.021-21.639a30.275 30.275 0 01-1.491-4.448l-2.482-8.106c-.013-.374-.981-5.581-2.226-11.983-2.316-11.9-2.365-12.084-4.7-18.75l-2.37-6.736-2.7-2.621-2.7-2.621-10.636-3.15c-5.851-1.734-13.423-4.034-13.538-4.034l-.016.029-3.348-.994c-1.972-.585-4.2-1.248-4.948-1.472a4.859 4.859 0 01-1.64-.74c-.155-.187-5.555-1.347-12.135-2.608zm-3.07 54.084a24.637 24.637 0 002.805 2.466c1.6 1.3 4.419 3.847 6.263 5.656 1.889 1.854 3.38 3.126 3.58 3.062.2.19 5.442 3.145 9.365 4.983 6.639 3.11 7.452 3.425 9.33 3.615 1.133.118 2.132.227 2.223.246a33.643 33.643 0 00-1.582-4.064c-1.373-3.217-1.9-4.173-2.466-4.459-.4-.2-.716-.5-.716-.681.005-.631-10.829-5.242-12.458-5.45v-.008c-.281-.243-16.223-5.477-16.343-5.365zm34.6 14.118a22.024 22.024 0 001.531 3.882l1.691 3.738 8.368 5.042c4.6 2.773 8.475 5.047 8.608 5.055s.179-.313.107-.708-.385-2.111-.689-3.81l-.558-3.089-1.761-1.512c-1.472-1.266-3.016-2.1-9.45-5.13-4.225-1.987-7.758-3.551-7.842-3.468z"></path>
                        <path d="M742.593 7229.538c-4.55-.745-31.479-7.55-32.131-8.12-.249-.214 20.428-52.85 20.965-53.371.275-.27 3.845 1.112 8.453 3.273 6.092 2.859 8.528 3.74 10.324 3.74 2.065 0 3.735.842 13.781 6.941 11.09 6.733 11.585 7.11 16.712 12.7l5.282 5.763-6.794 9.7-6.792 9.7-10.994 5.36c-6.046 2.95-11.456 5.338-12.023 5.311s-3.62-.479-6.783-.997z"></path>
                        <path d="M691.313 7212.461c-15.854-7.77-29.483-15-29.7-15.758-.067-.235 5.846-4.571 13.14-9.64l13.26-9.215 4.379-8.069a141.543 141.543 0 007.208-15.723l2.827-7.652 4.034 1.619c3.089 1.24 5.629 2.923 10.863 7.2 3.759 3.07 7.97 6.727 9.357 8.13l2.525 2.549-10.618 27.1c-5.843 14.908-10.882 27.092-11.2 27.076s-7.55-3.444-16.071-7.617z"></path>
                        <path d="M649.423 7197.689c-1.071-.107-3.847-1.464-6.72-3.286a32.744 32.744 0 00-5.581-3.107 5.628 5.628 0 00-2.172 1.09 3.724 3.724 0 01-1.966.916c-.267-.1-10.439-10.006-22.606-22.026-14.983-14.8-21.975-22.069-21.676-22.52.243-.369 3.356-3.85 6.92-7.737s6.514-7.123 6.554-7.187 7.208-1.3 15.934-2.752c15.376-2.552 16.185-2.632 26.5-2.632h10.644l13.279 4.66c10.89 3.821 30.557 11.518 31.313 12.253.582.566-6.255 16.835-9.789 23.3l-4.147 7.58-13.6 9.477c-7.481 5.215-14.029 9.487-14.553 9.5a14.842 14.842 0 00-3.73 1.336 9.562 9.562 0 01-4.6 1.144z"></path>
                        <path d="M662.303 7127.633l-6.5-2.327-11.037.024c-9.586.019-12.186.214-19.768 1.491l-8.731 1.467-2.057-4.08c-1.13-2.244-3.658-8.512-5.616-13.931s-4.756-12.509-6.22-15.761l-2.661-5.913 3.532-6.46 3.532-6.46 38.532-11.5 38.532-11.5-.222 16.282c-.208 15.152-.318 16.685-1.6 22.1l-1.373 5.822 2.223 3.505a26.552 26.552 0 012.215 3.893 6.773 6.773 0 01-2.439 1.5c-2.089.956-2.84 1.785-5.333 5.883a81.872 81.872 0 00-5.413 11.561 48.806 48.806 0 01-2.805 6.762c-.16-.016-3.217-1.077-6.792-2.357z"></path>
                        <path d="M685.935 7100.296l-2.5-3.973 1.146-4.232c.991-3.65 1.232-6.76 1.758-22.563l.609-18.331 4.462-1.777 4.462-1.774 7.994 3.008c4.4 1.654 9.356 3.5 11.026 4.1l3.033 1.09 13.73-3.786c7.553-2.084 13.834-3.687 13.963-3.561.307.3.163 51.226-.147 51.514-.131.123-5.5-.775-11.927-1.993l-11.689-2.212-14.935 3.746c-8.213 2.063-15.731 3.967-16.7 4.235-1.761.481-1.787.457-4.278-3.489z"></path>
                        <path d="M764.407 7106.348l-15.913-4.74-.112-8.969c-.061-4.935.019-17.1.174-27.028l.283-18.058 9.105-1.4a195.129 195.129 0 0119.841-1.868l10.732-.465 5.734 1.659 5.734 1.662.3 3.334c.166 1.836 1.152 7.815 2.193 13.289l1.892 9.95 7.8 9.69 7.8 9.688-19 9.006c-10.449 4.953-19.368 9-19.822 9s-7.986-2.145-16.739-4.75z"></path>
                        <path d="M843.373 7177.946l-28.7-5.392-7.15-3.329-7.15-3.329-1.611-5.76c-.887-3.169-2.6-10.829-3.81-17.022-2.811-14.4-6.134-24.431-9.159-27.639a8.181 8.181 0 01-1.886-2.429c.508-.441 38.444-18.163 38.564-18.016.069.088 5.531 7.949 12.13 17.468l12 17.3 2.458 8.857 2.458 8.854 2.552.55c7.625 1.638 19.525 22.3 19.4 33.675-.011 1.05-.281 1.683-.705 1.651-.377-.027-13.6-2.477-29.389-5.445z"></path>
                        <path d="M729.133 7313.871l.069-2.76h0c.1-4.237-1.242-12.215-3.965-23.485-2.015-8.349-2.455-11.085-2.367-14.759.075-3.2-.39-6.92-1.6-12.811-1.576-7.655-1.656-8.587-1.042-11.951.518-2.832 5.571-18.758 6.19-19.517a38 38 0 015.052 1.17c2.709.729 8.149 1.817 12.09 2.418l7.163 1.09 11.839-5.827 11.839-5.83 6.511-9.394a111.88 111.88 0 016.9-9.4c1.077 0 62.143 67.2 62.116 68.352"></path>
                        <path d="M698.865 7311.3a175.184 175.184 0 01-16.154-7.553c-2.744-1.611-5.694-3.284-6.554-3.711s-10.767-3.262-22.01-6.292-25.01-6.88-30.6-8.555l-10.155-3.04 1.932-2.346c1.061-1.29 3.791-4.115 6.065-6.276 7.027-6.671 20.182-22.144 31-36.459l10.34-13.679 4.147-2.033 4.147-2.033 1.94-5.239c1.069-2.88 2.063-5.525 2.21-5.88.176-.422 5.9 2.105 16.731 7.4 15.013 7.329 17.139 8.213 24.115 10.019 4.208 1.09 7.705 2.017 7.775 2.065s-1.077 3.487-2.543 7.647a109.214 109.214 0 00-3.524 12.012c-.844 4.382-.831 4.582.783 12.571a96.409 96.409 0 011.817 13.749c.136 4.224.756 8.023 2.482 15.189 2.6 10.8 4.261 21.337 3.741 23.741l-.35 1.619-6.158.644c-3.385.355-7.024.74-8.085.858-1.507.163-4.382-.807-13.092-4.411z"></path>
                        <path d="M521.614 7242.338c-2.7-.951-4.86-1.929-4.8-2.175s9.167-13.287 20.241-28.978 21.3-30.2 22.734-32.245c2.175-3.1 24.623-26.891 25.785-27.321.2-.075 10.735 10 23.407 22.389s23.259 22.528 23.538 22.528a8.113 8.113 0 002.306-1.29l1.806-1.29 4.817 2.968c6.188 3.81 8.836 4.264 12.84 2.2l2.739-1.411 7.828 4.253 7.828 4.253-2.143 5.715-2.143 5.712-3.9 1.817-3.9 1.814-10.326 13.706c-10.6 14.064-25.766 31.893-33.461 39.323a66.5 66.5 0 00-5.349 5.629"></path>
                        <path d="M689.304 6980.091l-.369 1.9c-.2 1.042-2.421 13.549-4.927 27.792l-4.555 25.9 2.121 5.688a34.6 34.6 0 012.081 7.235l-.04 1.55-39.222 11.713-39.224 11.71-3.96 7.273a66.687 66.687 0 01-4.248 7.235c-.16-.024-6.784-2.725-14.719-6h0c-7.938-3.281-14.62-6.033-14.85-6.118s.011-1.29.542-2.68c1.424-3.732 1.159-3.829-7.812-2.848a67.429 67.429 0 01-7.818.614 18.342 18.342 0 011.181-4.269 48.883 48.883 0 013.727-7.484"></path>
                        <path d="M910.65 7070.595c-.772.673-14.839 6.356-19.865 8.023-5.907 1.958-6.995 2.148-14.906 2.578-8.242.449-8.654.422-12.079-.783l-3.543-1.245-18.518 6.573c-10.182 3.612-18.665 6.562-18.849 6.551s-3.853-4.438-8.154-9.84h0l-7.823-9.819-2-10.716a115.367 115.367 0 01-1.934-13.45c.077-3.254.342-3.075-7.981-5.408-3.38-.946-6.142-1.884-6.137-2.087s3.628-8.165 8.05-17.7l8.042-17.332-.88-15.076c-.481-8.293-.783-15.181-.668-15.3"></path>
                        <path d="M897.288 7186.811c-10.855-1.25-20.049-2.284-20.426-2.3-.409-.013-.671-.737-.647-1.785a53.686 53.686 0 00-.994-7.2c-.842-4.424-1.721-6.81-4.7-12.774-3.206-6.41-4.219-7.9-8.039-11.785-3.321-3.38-4.9-4.587-6.559-5.015l-2.185-.564-2.351-8.373-2.354-8.371-11.756-16.872c-6.466-9.279-11.753-17.043-11.748-17.254s7.844-3.155 17.42-6.546l17.412-6.164 2.915 1.117c2.728 1.045 3.511 1.093 12.2.753 9.137-.358 9.4-.4 16.284-2.688 3.847-1.277 9.934-3.658 13.522-5.285s6.637-2.853 6.773-2.72c.876.855 4.823 27.925 6.18 42.425.874 9.33 1.99 20.5 2.479 24.821 1.122 9.942 1.6 32.953.879 42.03l-.556 6.938-2-.059c-1.107-.029-10.891-1.079-21.749-2.329z"></path>
                    </g>
                    <g
                        ref={paris}
                        className="title_bilan_pour_paris_en_2019 is-hidden"
                        data-name="Groupe 5317"
                        transform="translate(-452.021 592.659)"
                    >
                        <path
                            fill="#c1ce27"
                            d="M0 0H125V41H0z"
                            data-name="Rectangle 2460"
                            transform="translate(1151 6602.025)"
                        ></path>
                        <g data-name="Groupe 5314" transform="translate(-120)">
                            <text
                                fill="#fff"
                                data-name="PARIS"
                                fontFamily="Orkney-Bold, Orkney"
                                fontSize="28"
                                fontWeight="700"
                                transform="translate(1334 6632.025)"
                            >
                                <tspan x="-39.55" y="0">
                                    PARIS
                                </tspan>
                                <tspan
                                    fontFamily="Orkney-Medium, Orkney"
                                    fontWeight="500"
                                ></tspan>
                            </text>
                            <path
                                fill="none"
                                stroke="#c1ce27"
                                strokeWidth="1"
                                d="M0 0L0 129.685"
                                data-name="Ligne 659"
                                transform="translate(1271.5 6513.841)"
                            ></path>
                        </g>
                    </g>
                </g>
                <g
                    className="cursor_pointer plaine_commune"
            data-name="Groupe 5323"

                    style={
                        activeZone && activeZone === "plaine_commune"
                            ? { filter: `url(#dropshadow)` }
                            : {}
                    }
                    onMouseOver={(e) => {
                        handleLinkHover("plaine_commune");
                        setActiveZone("plaine_commune");
                        plaine_commune?.current?.classList?.remove("is-hidden");
                    }}
                    onMouseOut={(e) => {
                        handleLinkHover(null);
                        setActiveZone(null);
                        plaine_commune?.current?.classList?.add("is-hidden");
                    }}
                    onClick={() => handleClick(`${urlBase}plaine-commune`)}
                >
                    <g
                        fill="#83dfcc"
                        stroke="#fffef6"
                        strokeWidth="0.5"
                        data-name="Groupe 5283"
                        transform="translate(698.979 6556.446)"
                    >
                        <path
                            d="M269.458 282.956l-51.191-1.94-11.919.16 1.916-74.652 21.911-10.785 23.06 15.5 41.076-8.16 23.445 14.981 1.3 32.523-25.55 3.225z"
                            data-name="93001 AUBERVILLIERS"
                        ></path>
                        <path
                            d="M324.475 222.806l-6.709-4.716-23.445-14.981-41.068 8.16-23.071-15.5 34.177-67.678 29.237-26.878 15.785-12.507 35.094 45.3-7.4 24.252 19.234 14.422-22.793 40.159z"
                            data-name="93027 LA LCOURNEUVE"
                        ></path>
                        <path
                            d="M133.102 122.405l-19.507-15.691-74.363-19.04-29.077.836L0 59.089l27.089-28.561 38.733 16 18.657 14.791 21.954-4.908 13.257 16.554 33.45 34.287-10.5-1.133z"
                            data-name="93031 EPINAY-SUR-SEINE"
                        ></path>
                        <path
                            d="M83.602 225.756l5.862-10.65 17.161-15.842 20.15-34.134-2.8-38.6-61.993-24.786-55.249-11.69 3.447-1.667 29.085-.82 74.363 19.042 19.545 15.691 8.777 34.407-23.527 41.816z"
                            data-name="93039 L'ILE-SAINT-DENIS"
                        ></path>
                        <path
                            d="M221.489 104.167l-51.8-12.2 3.829-58.659L207.399-.004l26.119 8.568-7.315 38.562-17.805 19.846z"
                            data-name="93059 PIERREFITTE-SUR-SEINE"
                        ></path>
                        <path
                            d="M169.157 281.542l-7.625-37.733-43.181-45.134 23.525-41.818-8.774-34.4 9.461-16.282 10.5 1.149 16.624-15.3 51.878 12.2 36.894 9.773 35.174-12.678-29.269 26.875-34.174 67.681-21.876 10.774-1.956 74.665z"
                            data-name="93066 SAINT-DENIS"
                        ></path>
                        <path
                            d="M83.792 285.659l-16.359-52.516 16.169-7.355 34.752-27.049 43.181 45.134 7.619 37.741-58.314 1.419z"
                            data-name="93070 SAINT-OUEN"
                        ></path>
                        <path
                            d="M293.634 101.222l-35.171 12.681-36.974-9.773-13.14-37.2 17.855-19.849 7.315-38.562 17.238 2.816 66.546 58.728-7.81 18.644z"
                            data-name="93072 STAINS"
                        ></path>
                        <path
                            d="M152.908 107.255L119.5 72.968l27.733-45.786 26.055 6.166-3.829 58.659z"
                            data-name="93079 VILLETANEUSE"
                        ></path>
                    </g>
                    <g
                        ref={plaine_commune}
                        className="title_plaine_commune is-hidden"
                        data-name="Groupe 5318"
                        transform="translate(-229 -97.25)"
                    >
                        <path
                            fill="#83dfcc"
                            d="M0 0H285V41H0z"
                            data-name="Rectangle 2460"
                            transform="translate(1225 6602.025)"
                        ></path>
                        <g data-name="Groupe 5314">
                            <text
                                fill="#fff"
                                data-name="plaine commune"
                                fontFamily="Orkney-Bold, Orkney"
                                fontSize="28"
                                fontWeight="700"
                                transform="translate(1367 6632.025)"
                            >
                                <tspan x="-127.876" y="0">
                                    PLAINE COMMUNE
                                </tspan>
                                <tspan
                                    fontFamily="Orkney-Medium, Orkney"
                                    fontWeight="500"
                                ></tspan>
                            </text>
                            <path
                                fill="none"
                                stroke="#83dfcc"
                                strokeWidth="1"
                                d="M0 0L0 194"
                                data-name="Ligne 659"
                                transform="translate(1225.5 6602.525)"
                            ></path>
                        </g>
                    </g>
                </g>
                <g data-name="Groupe 5325">
                    <g
                        fill="#ff7a00"
                        stroke="#fff"
                        strokeWidth="0.5"
                        data-name="Groupe 5282"
                        transform="translate(968.438 6767.357)"
                    >
                        <g
                            className="cursor_pointer est_ensemble"
                            data-name="Groupe 5281"
                            style={
                                activeZone && activeZone === "est_ensemble"
                                    ? { filter: `url(#dropshadow)` }
                                    : {}
                            }
                            onMouseOver={(e) => {
                                handleLinkHover("est_ensemble");
                                setActiveZone("est_ensemble");
                                est_ensemble?.current?.classList?.remove(
                                    "is-hidden"
                                );
                            }}
                            onMouseOut={(e) => {
                                handleLinkHover(null);
                                setActiveZone(null);
                                est_ensemble?.current?.classList?.add("is-hidden");
                            }}
                            onClick={() =>
                                handleClick(`${urlBase}est-ensemble`)
                            }
                        >
                            <path
                                d="M56.7 159.881l-27.506-20.407-4.513-21.967 23.445 3.58 10.457 20.343z"
                                data-name="93061 LE LPRE-SAINT-GERVAIS"
                            ></path>
                            <path
                                d="M69.041 250.064l-5.44-69.482 18.149-17.636 25.718-2.394 18.5 5.018-3.455 9.324-32.331 58.546z"
                                data-name="93006 BAGNOLET"
                            ></path>
                            <path
                                d="M102.142 92.432L66.931 57.563 55.02 11.895l9.143-9.926L179.18 34.054l49.842-21.075-14.291 45.07-76.207 25.155z"
                                data-name="93008 BOBIGNY"
                            ></path>
                            <path
                                d="M259.834 126.719l-27.121-6.3-13.164-1.459 5.977-24.714-10.882-36.186 14.294-45.07-2.528-7.8L240.202.004l32.956 11.224-1.461 25.895 23.1 55.936-11.8 22.448z"
                                data-name="93010 BONDY"
                            ></path>
                            <path
                                d="M63.601 180.622l-7.019-20.749 1.651-18.443 35.091-30.824 14.1 49.978-25.67 2.391z"
                                data-name="93045 LES LLILAS"
                            ></path>
                            <path
                                d="M153.864 265.675l-26.277-6.34-21.569 15.173-27.244-1.8-7.011.342-2.723-22.982 21.15-16.592 32.331-58.546 19.456 10.476 23.942-25.609 35.091 1.651 18.355 32.165 23.95 8.9 2.418 23.429-72.675 23.143z"
                                data-name="93048 MONTREUIL"
                            ></path>
                            <path
                                d="M201.026 161.444l-35.091-1.651-5.058-24.674-17.7-14.957-4.945-36.991 76.279-25.152 10.874 36.168-5.974 24.73 13.177 1.459z"
                                data-name="93053 NOISY-LE-SEC"
                            ></path>
                            <path
                                d="M58.314 141.43l-10.348-20.343-23.445-3.583-5.744-26.245L0 72.044l23.827-29.157 25.67-3.225-1.3-32.523 6.7 4.716 11.916 45.668 35.214 34.869-8.809 18.181z"
                                data-name="93055 PANTIN"
                            ></path>
                            <path
                                d="M166.047 159.841l-23.942 25.606-19.464-10.473 3.455-9.324-18.507-5.018-14.136-49.978 8.806-18.181 36.282-9.252 4.978 36.991 17.588 14.957z"
                                data-name="93063 ROMAINVILLE"
                            ></path>
                            <path
                                d="M285.435 231.788l-39.662-5.816-2.418-23.429-23.95-8.91-18.355-32.165 31.687-41 27.121 6.3 22.488 12.715 10.524 22.392 26.595.168z"
                                data-name="93064 ROSNY-SOUS-BOIS"
                            ></path>
                        </g>
                    </g>
                    <g data-name="Groupe 5315">
                        <g
                            ref={est_ensemble}
                            className="title_est_ensemble is-hidden"
                            data-name="Groupe 5314"
                        >
                            <path
                                fill="#ff7a00"
                                d="M0 0H219V41H0z"
                                data-name="Rectangle 2460"
                                transform="translate(1225 6602.025)"
                            ></path>
                            <text
                                fill="#fff"
                                data-name="Est Ensemble"
                                fontFamily="Orkney-Bold, Orkney"
                                fontSize="28"
                                fontWeight="700"
                                transform="translate(1334 6632.025)"
                            >
                                <tspan x="-100.114" y="0">
                                    EST ENSEMBLE
                                </tspan>
                                <tspan
                                    fontFamily="Orkney-Medium, Orkney"
                                    fontWeight="500"
                                ></tspan>
                            </text>
                            <path
                                fill="none"
                                stroke="#e88122"
                                strokeWidth="1"
                                d="M0 0L0 194"
                                data-name="Ligne 659"
                                transform="translate(1225.5 6602.525)"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
